import React from 'react';
import { Phone, Check, MessageCircle, Download } from 'lucide-react';
import { motion } from 'framer-motion';
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";

const StructureWorkPackages = () => {
    const packages = [
        {
            name: 'Silver work packages',
            price: '950',
            features: [
                'Ambuja Cement + Waterproof',
                'Nirmaan Tmt',
                'Parapet Wall Included',
                'Sunken Slab Included',
            ],
            ribbonColor: '#008000',
            ribbonDarkColor: '#006400',
            buttonColor: '#008000',
            downloadLink: '#' // Placeholder
        },
        {
            name: 'Silver work packages',
            price: '950',
            features: [
                'Ambuja Cement + Waterproof',
                'Nirmaan Tmt',
                'Parapet Wall Included',
                'Sunken Slab Included',
            ],
            ribbonColor: '#008000',
            ribbonDarkColor: '#006400',
            buttonColor: '#008000',
            downloadLink: '#' // Placeholder
        },
        {
            name: 'Silver work packages',
            price: '950',
            features: [
                'Ambuja Cement + Waterproof',
                'Nirmaan Tmt',
                'Parapet Wall Included',
                'Sunken Slab Included',
            ],
            ribbonColor: '#008000',
            ribbonDarkColor: '#006400',
            buttonColor: '#008000',
            downloadLink: '#' // Placeholder
        },
        {
            name: 'Gold work packages',
            price: '999',
            features: [
                'Acc Cement + Waterproof',
                'Kay 2 Tmt (Kamdhenu)',
                'Parapet Wall Included',
                'Designer Staircase',
            ],
            ribbonColor: '#008000',
            ribbonDarkColor: '#006400',
            buttonColor: '#008000',
            downloadLink: '#' // Placeholder
        },
        {
            name: 'Platinum work packages',
            price: '1050',
            features: [
                'Ultratech + Waterproof',
                'Tata / Jindal Tmt',
                'Parapet Wall Included',
                'Designer Staircase',
            ],
            ribbonColor: '#008000',
            ribbonDarkColor: '#006400',
            buttonColor: '#008000',
            downloadLink: '#' // Placeholder
        },
        // Adding duplicates for demonstration if needed, or just keeping 3. 
        // If only 3, and we show 3 on desktop, it won't scroll much unless looped.
        // But user asked for carousel format.
    ];

    return (
        <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="mb-12"
                >
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                        Structure Work Packages
                    </h2>
                    <p className="text-gray-600 max-w-3xl">
                        FCV Constructions provides customizable structure work packages that cover everything from the foundation to complete exterior and interior plastering, ensuring top-quality construction.
                    </p>
                </motion.div>

                <Carousel
                    opts={{
                        align: "start",
                        loop: true,
                    }}
                    plugins={[
                        Autoplay({
                            delay: 3000,
                        }),
                    ]}
                    className="w-full"
                >
                    <CarouselContent className="-ml-4">
                        {packages.map((pkg, index) => (
                            <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3">
                                <div className="h-full bg-white rounded-lg shadow-[0_4px_20px_rgba(0,0,0,0.08)] border border-gray-100 relative overflow-hidden flex flex-col hover:shadow-xl transition-shadow duration-300">

                                    {/* Ribbon Style - Flush Left */}
                                    <div className="absolute top-8 left-0 z-10">
                                        {/* Ribbon Body */}
                                        <div
                                            className="text-white py-2 pl-6 pr-10 text-sm font-semibold shadow-sm relative z-10"
                                            style={{
                                                backgroundColor: pkg.ribbonColor,
                                                clipPath: 'polygon(0 0, 100% 0, 92% 50%, 100% 100%, 0 100%)'
                                            }}
                                        >
                                            {pkg.name}
                                        </div>
                                        {/* Ribbon Fold/Shadow Effect - Subtle darkening if needed, 
                           but simple flush left look is effectively achieved by the shape and positioning.
                           The previous complex structure was a bit overkill for a flat flush ribbon.
                       */}
                                    </div>

                                    <div className="relative pt-24 pb-8 px-6 flex-grow flex flex-col">
                                        {/* Price */}
                                        <div className="mb-6">
                                            <div className="flex items-baseline gap-1">
                                                <span className="text-3xl font-bold text-gray-800">₹ {pkg.price}</span>
                                                <span className="text-gray-500 font-medium">/ Sqft</span>
                                            </div>
                                        </div>

                                        {/* Inquiry Button */}
                                        <a
                                            href="tel:+919039200574"
                                            className="w-full text-white font-bold py-3 px-4 rounded-full flex items-center justify-center gap-2 mb-8 transition-opacity hover:opacity-90"
                                            style={{ backgroundColor: pkg.buttonColor }}
                                        >
                                            <Phone className="w-5 h-5 fill-current" />
                                            INQUIRY NOW
                                        </a>

                                        {/* Features */}
                                        <ul className="space-y-3 mb-8 flex-grow">
                                            {pkg.features.map((feature, i) => (
                                                <li key={i} className="flex items-start gap-3">
                                                    <div className="mt-1 flex-shrink-0">
                                                        <div className="w-5 h-5 rounded-full bg-green-500 flex items-center justify-center">
                                                            <Check className="w-3.5 h-3.5 text-white stroke-[3]" />
                                                        </div>
                                                    </div>
                                                    <span className="text-gray-600 text-sm font-medium">{feature}</span>
                                                </li>
                                            ))}
                                        </ul>

                                        {/* Bottom Buttons */}
                                        <div className="mt-auto space-y-3">
                                            <a
                                                href="https://wa.me/919039200574"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="w-full border border-gray-200 rounded-full py-2.5 px-4 flex items-center justify-center gap-2 text-green-600 font-semibold hover:bg-green-50 transition-colors"
                                            >
                                                <MessageCircle className="w-5 h-5" />
                                                <span className="uppercase text-sm">Chat on WhatsApp</span>
                                            </a>
                                            <a
                                                href={pkg.downloadLink}
                                                download
                                                className="w-full border border-gray-200 rounded-full py-2.5 px-4 flex items-center justify-center gap-2 font-semibold hover:bg-orange-50 transition-colors"
                                                style={{ color: pkg.buttonColor }}
                                            >
                                                <Download className="w-5 h-5" />
                                                <span className="uppercase text-sm">Download Brochure</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                    <div className="hidden md:block">
                        <CarouselPrevious className="-left-4 lg:-left-12" />
                        <CarouselNext className="-right-4 lg:-right-12" />
                    </div>
                </Carousel>

            </div>
        </section>
    );
};

export default StructureWorkPackages;
